export function formatDriverName(driver: {
  name?: string | null
  surname?: string | null
}): string {
  return `${driver.surname ?? ''} ${driver.name ?? ''}`.trim()
}
